if (customElements.get('quick-add-direct') === undefined) {
  customElements.define('quick-add-direct', class QuickAddDirect extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('.qad-add') || this.querySelector('button');
      this.input = this.querySelector('.qad-input');

      const minus = this.querySelector('.qad-minus');
      const plus = this.querySelector('.qad-plus');
      if (minus) minus.addEventListener('click', (event) => { event.preventDefault(); this.step(-1); });
      if (plus) plus.addEventListener('click', (event) => { event.preventDefault(); this.step(1); });

      if (this.input) {
        // Entrée dans le champ quantité = ajout direct au panier
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            event.stopPropagation();
            this.addToCart(event);
          }
        });
        // Nettoie la valeur saisie à la main (vide, 0, négatif -> 1)
        this.input.addEventListener('change', () => {
          this.input.value = Math.max(1, parseInt(this.input.value, 10) || 1);
        });
      }

      if (this.button) {
        this.button.addEventListener('click', this.addToCart.bind(this));
      }
    }

    step(delta) {
      if (!this.input) return;
      const value = Math.max(1, (parseInt(this.input.value, 10) || 1) + delta);
      this.input.value = value;
    }

    getQuantity() {
      if (!this.input) return 1;
      return Math.max(1, parseInt(this.input.value, 10) || 1);
    }

    async addToCart(event) {
      event.preventDefault();
      if (this.busy || this.button.hasAttribute('disabled')) return;
      this.busy = true;

      const originalContent = this.button.innerHTML;

      try {
        const addUrl = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
        const response = await fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(this.dataset.variantId, 10), quantity: this.getQuantity() })
        });

        if (!response.ok) throw new Error('add-to-cart failed');

        this.button.innerHTML = '<span class="qad-check">✓</span>';
        if (this.input) this.input.value = 1;

        document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

        const cartResponse = await fetch('/cart.js');
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.dispatchEvent(new CustomEvent('cart:update', { detail: cart }));
          document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        }
      } catch (error) {
        this.button.innerHTML = '<span class="qad-check">✕</span>';
        console.error(error);
      }

      setTimeout(() => {
        this.button.innerHTML = originalContent;
        this.busy = false;
      }, 1400);
    }
  });
}